import React, { Component, Fragment, createRef } from 'react';
import { Spin } from 'antd';
import SparameterSetting from '../../../../services/Result/Public/sparameter/SparameterSetting';
import Parameters from '@/services/Sierra/Sparameter/parameter';
import DisplayMode from '@/components/Sparameter/displayMode';
import ResultRightMenu from '@/services/Result/Public/resultRightMenu';
import { Modes } from '../../constants';
import { strDelimited } from '@/services/helper/split';
import ResultLayout from '@/services/Result/Public/resultLayout';
import { axisFormat } from '@/services/Result/Public/sparameter/dataHelper';
import { getSweepList } from '@/services/Sierra';
import photo from '@/components/PublicSvg/photo.svg';
import saveSvg from 'save-svg-as-png';
/* import ResultZoom from '../../../../components/ResultTopMenu/resultZoom'; */
import ResultTreeList from '../../../../components/ResultTreeList';
import { END_TO_END, RESULT, SUB_TITLE } from '../../../../components/ResultTreeList/nodeRender';
import { SIERRA } from '../../../../constants/pageType';
import {
  endToEndItemTreeSignalTitle,
  endToEndItemTreeRowTitle,
  endToEndItemTitle, experimentListTitleRender,
  getSignalTitle,
  RESULT_TREE_SIGNAL,
  getSweepPinTitle,
  RESULT_TREE_SWEEP_PIN,
  sweepExpCheckTitle
} from './resultTreeRender';
import './new.css';

class Sparameter extends Component {

  constructor(props) {
    super(props);
    this.uploadSP = createRef();
    this.svgRef = createRef();
    this.uploadSnpRef = createRef();
    this.state = {
      loading: true,
      displayMode: 'Default',
    }
  }

  onRef = (ref) => {
    this.sparameterSetting = ref;
  }

  componentDidMount = () => {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    if (this.props.resultOpera) {
      this.setDefaultOpreation()
    }
  }

  setDefaultOpreation = () => {
    const { resultOpera = {} } = this.props;
    const { displayMode, axis, setting } = resultOpera;
    const newState = {};
    if (displayMode) {
      newState['displayMode'] = displayMode
    }
    if (axis) {
      this.sparameterSetting.setAxis(axis);
    }
    if (setting) {
      this.sparameterSetting.setSetting(setting)
    }
    this.setState({
      ...newState
    }, () => {
      if (displayMode) {
        if (displayMode === 'Default') {
          this.props.defaultResultList(displayMode);
        } else {
          this.props.findResultList(displayMode);
        };
      }
    })
  }

  updateDisplayModeModel = (displayMode) => {
    this.setState({
      displayMode
    })
  }

  changeAxis = (axis) => {
    const xUnit = this.getXUnit();
    this.sparameterSetting.setAxis(axisFormat(xUnit, axis));
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resize);
  }

  screenChange = () => {
    window.addEventListener('resize', this.resize);
  }

  resize = () => {
    this.resultRightMenu.updateFileListState();
  }

  changeFileListBottom = () => {
    this.resultRightMenu.updateFileListState();
  }

  removeAllCurves = () => {
    const { portSelect } = this.props;
    const selects = Object.values(portSelect).reduce((a, b) => {
      return a.concat(b);
    }, []);
    let ports = [...selects];
    const removeCurves = ports.map(curve => {
      const [fileId, row, col] = strDelimited(curve, "::");
      return { row, col, id: fileId };
    });
    if (removeCurves.length) {
      Parameters.removeCurves(removeCurves);
    };
  }

  getSetting = () => {
    return this.sparameterSetting.getSetting();
  }

  getAxis = () => {
    return this.sparameterSetting.getAxis();
  }

  getXUnit = () => {
    return this.sparameterSetting.getXUnit()
  }

  axisChangeCB = (axis, value) => {
    const setting = this.getSetting();
    Parameters.changeAxis(axis, { param: setting.parameter, value: setting.value, scale: value })
    if (this.props.setResultOpera) {
      const axis = this.getAxis();
      this.props.setResultOpera({ axis })
    }
  }

  updateRangeCB = (update, min, max) => {
    const axis = this.getAxis();
    if (update === 'x') {
      Parameters.updateRange('x', { start: min, end: max })
    } else {
      Parameters.updateRange('y', { start: axis['yMin'], end: axis['yMax'], yScale: axis['yScale'] })
    }
    if (this.props.setResultOpera) {
      this.props.setResultOpera({ axis })
    }
  }

  printResult = (e) => {
    e.preventDefault();
    const options = {
      backgroundColor: '#ffffff',
      encoderOptions: 1
    }
    document.querySelector(".plot") && saveSvg.saveSvgAsPng(document.querySelector(".plot"), "Network_parameter_result.png", options);
  }

  resultLeft = () => {
    const { loading } = this.state;
    return (
      <Spin spinning={loading} size='large'>
        <div className='sierra-result-parameter-right'>
          <svg ref={this.svgRef}></svg>
          {/* {ResultZoom({
            zoomIn: Parameters.zoomIn,
            zoomOut: Parameters.zoomOut,
            fitView: Parameters.fitView
          })} */}
          <div className='sierra-result-curve-right'>
            <div className='photo-box' onClick={this.printResult}>
              <img src={photo} alt="" className='sierra-photo' />
            </div>
          </div>
        </div>
      </Spin>
    )
  }

  getCurrentSelects = () => {
    let { portSelect = {} } = this.props;
    return Object.values(portSelect).reduce((a, b) => {
      return a.concat(b);
    }, []);
  }

  resultRightMenuOnRef = (ref) => {
    this.resultRightMenu = ref;
  }

  displayModeChange = (e) => {
    const value = e && e.target ? e.target.value : this.state.displayMode;
    this.removeAllCurves();
    this.props.setChannelState({}, 'portSelect')
    if (this.props.setResultOpera) {
      this.props.setResultOpera({ displayMode: value, portSelect: {} })
    }
    this.setState({
      displayMode: value,
    }, () => {
      if (value === 'Default') {
        this.props.defaultResultList(value);
      } else {
        this.props.findResultList(value);
      };
    })
  }

  getDisplayMode = () => {
    return this.state.displayMode;
  }

  setLoading = (bool) => {
    this.setState({ loading: bool });
  }

  rightTopRender = () => {
    const { displayMode } = this.state;
    //Virtual component hide insertion loss
    const { hideIL } = this.props;
    const _Modes = hideIL ? Modes.filter(item => item.value !== "IL") : Modes;
    return (
      <DisplayMode
        displayModeChange={this.displayModeChange}
        displayMode={displayMode}
        Modes={_Modes}
      />
    )
  }

  getMultiSweepList = (allPortSelect, experimentList, portSelect, displayMode) => {
    const allKeys = Object.keys(allPortSelect);
    const data = allKeys.map(key => {
      const sweepData = getSweepList(allPortSelect[key][displayMode], experimentList, portSelect);
      return { ...sweepData, pcb: key }
    })
    return data
  }

  getResultListByVCPcb = (resultList, hasVcPCBs) => {
    if (!hasVcPCBs || !hasVcPCBs.length) {
      return resultList;
    }
    for (let pcb of hasVcPCBs) {
      if (resultList[pcb] && resultList[pcb].IL) {
        delete resultList[pcb].IL
      }

    }
    return resultList;
  }

  getFilesObj = (files, type) => {
    if (type === END_TO_END) {
      return {
        [END_TO_END]: files.filter(item => item.type === "end-to-end"),
      }
    }
    return {
      [RESULT]: files.filter(item => item.type !== "end-to-end"),
    }
  }

  resultTreeRender = (nodeData, actions) => {
    let children = null;
    const { sweep } = this.props;
    switch (nodeData.type) {
      case "end_to_end_signal":
        children = endToEndItemTreeSignalTitle(nodeData, actions);
        break;
      case "end_to_end_row":
        children = endToEndItemTreeRowTitle(nodeData, actions);
        break;
      case RESULT_TREE_SIGNAL:
        children = getSignalTitle(nodeData, actions);
        break;
      case RESULT_TREE_SWEEP_PIN:
        children = getSweepPinTitle(nodeData, actions);
        break;
      case SUB_TITLE:
        children = sweep ? sweepExpCheckTitle(nodeData, { ...actions, isSparameter: true }) : null
        break;
      default:
        break;
    }
    return children;
  }

  getTreeCheckedKeys = (type) => {
    const { portSelect, sweep } = this.props;
    const allKeys = Object.keys(portSelect).map(key => [...(portSelect[key] || [])]).flat(2);
    if (type === END_TO_END) {
      return allKeys.filter(item => item.match(/^end-to-end@/));
    }

    if (sweep) {
      const { displayMode } = this.state;
      return this.props.getSweepTreeCheckedKeys(displayMode)
    }
    return allKeys.filter(item => !item.match(/^end-to-end@/));
  }

  getEndToEndCurveColor = (nodeData) => {
    const { files } = this.props;
    const [fileId, row, col] = strDelimited(nodeData.id, "::");
    const file = files.find(item => item.type === "end-to-end" && item.id === fileId);
    const color = file && file.matrix && file.matrix[row] && file.matrix[row][col] ? file.matrix[row][col].color : "";
    return color;
  }

  resultTitleRender = (nodeData, actions) => {
    const { experimentList } = this.props;
    if (experimentList && experimentList.length) {
      return experimentListTitleRender(actions)
    }
  }

  resultListRender = () => {
    const { files, portSelect, resultList, hasVcPCBs, experimentList = null, allPortSelect = {}, sweep, expandedKeys,
      endToEndList, expandedEndToEndKeys, endToEndCurveMouseObj, endToEndTree, changeSelectAll } = this.props;
    const { displayMode } = this.state;
    /*     const multiRowSelectData = this.getMultiSweepList(allPortSelect, experimentList, portSelect, displayMode); */
    const _resultList = this.getResultListByVCPcb(resultList, hasVcPCBs);
    const showEndToEnd = ["RL", "IL"].includes(displayMode) && endToEndList && endToEndList.length;
    const endToEndClass = showEndToEnd ? "sierra-sparameter-result-content" : ""
    return (
      <Fragment>
        <ResultTreeList
          className={sweep ? `sierra-sparameter-sweep-tree sierra-sparameter-tree` : `sierra-sparameter-tree ${endToEndClass}`}
          type={RESULT}
          product={SIERRA}
          resultTitleList={[RESULT]}
          filesObj={this.getFilesObj(files)}
          isSparameter={true}
          multiFiles={true}
          displayMode={displayMode}
          resultList={_resultList}
          experimentList={experimentList}
          colorChange={this.props.colorChange}
          isParallel={sweep}
          checkStrictly={sweep}
          getTreeCheckedKeys={() => this.getTreeCheckedKeys(RESULT)}
          allPortSelect={allPortSelect}
          portSelect={portSelect}
          changePort={this.props.changePort}
          expandedKeys={expandedKeys}
          resultCurveCurrentClassName="result-tree-s-parameter-curve-current"
          updateExpandKeys={this.props.updateExpandKeys}
          changeSinglePort={this.props.changeSinglePort}
          // resultTreeRender={this.resultTreTitleRender}
          resultTitleRender={this.resultTitleRender}
          resultTreeRender={this.resultTreeRender}
          getSweepChecked={this.props.getSweepChecked}
          changeSelectAll={changeSelectAll}
          changeTreeCheckedKeys={this.props.changeTreeCheckedKeys}
        />
        {showEndToEnd ?
          <ResultTreeList
            resultTitleList={[END_TO_END]}
            endToEndList={endToEndList}
            resultList={endToEndTree}
            filesObj={this.getFilesObj(files)}
            customizeTitle={endToEndItemTitle}
            displayMode={displayMode}
            portSelect={portSelect}
            curveMouseObj={endToEndCurveMouseObj}
            expandedKeys={expandedEndToEndKeys}
            updateExpandKeys={this.props.updateEndToEndExpandedKeys}
            colorChange={this.props.colorChange}
            changePort={this.props.changeEndToEndPorts}
            resultCurveCurrentClassName="result-tree-s-parameter-curve-current"
            getCurveColor={this.getEndToEndCurveColor}
            resultTreeRender={this.resultTreeRender}
            getTreeCheckedKeys={() => this.getTreeCheckedKeys(END_TO_END)}
          /> : null}
      </Fragment>
    )
  }

  settingRender = () => {
    return (
      <SparameterSetting
        onRef={this.onRef}
        portSelectLen={this.getCurrentSelects().length}
        settingChangeCB={this.props.settingChangeCB}
        changeFileListBottom={this.changeFileListBottom}
        axisChangeCB={this.axisChangeCB}
        updateRangeCB={this.updateRangeCB}
      />
    )
  }

  resultRight = () => {
    return (
      <ResultRightMenu
        onRef={this.resultRightMenuOnRef}
        top={this.rightTopRender}
        resultList={this.resultListRender}
        setting={this.settingRender}
      />
    )
  }

  changeWidthCB = () => {
    const { plot2d } = this.props;
    if (plot2d && plot2d.curves && plot2d.curves.length) {
      plot2d.resetPlot();
      const axis = this.getAxis();
      const setting = this.getSetting();
      Parameters.changeAxis('x', { param: setting.parameter, value: setting.value, scale: axis.xScale });
      Parameters.changeAxis('y', { param: setting.parameter, value: setting.value, scale: axis.yScale });
    }
  }

  render() {
    const { className } = this.props;
    return (
      <div className={`sierra-touchstone-result-main ${className || ""}`}>
        <ResultLayout
          defaultRightWidth={350}
          resultLeft={this.resultLeft}
          resultRight={this.resultRight}
          changeWidthCB={this.changeWidthCB}
        />
      </div >
    )
  }
}

export default Sparameter;